

module.exports = __webpack_require__.stylable.create(
    "SectionText669868392",
    {"classes":{"root":"SectionText669868392__root","text":"SectionText669868392__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "SectionText669868392",
    null
);
